import { forwardRef } from "react";
import _ChipText, { _ChipTextProps } from "./_chip-text";

interface ChipSolidProps
  extends Omit<_ChipTextProps, "type">,
    Omit<React.HTMLAttributes<HTMLDivElement>, keyof _ChipTextProps> {}

const ChipSolid = forwardRef<HTMLDivElement, ChipSolidProps>(
  (
    {
      size = "20px",
      rounded = false,
      leftIcon = null,
      showRightIcon = false,
      ...props
    },
    ref,
  ) => {
    return (
      <_ChipText
        type="solid"
        size={size}
        rounded={rounded}
        leftIcon={leftIcon}
        showRightIcon={showRightIcon}
        ref={ref}
        {...props}
      />
    );
  },
);

ChipSolid.displayName = "ChipSolid";

export default ChipSolid;
